import React, { createContext, useContext, useState } from 'react';
import { apiRequest } from '../utils/apiHelper';
import { useAuth } from './AuthContext';
import { showError } from '../utils/toastHelper';


const CompanyContext = createContext();

export function CompanyProvider({ children }) {
  const { user, updateUserInfo, setToken } = useAuth();
  const [activeCompany, setActiveCompany] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCompanies = async () => {
    if (!user) return;

    // Sadece SUPER_ADMIN yetkisi varsa şirket listesini getir
    if (user.role !== 'SUPER_ADMIN') {
      if (user.companyId && !activeCompany) {
        setActiveCompany({
          id: user.companyId,
          name: user.companyName || 'Şirketiniz'
        });
      }
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await apiRequest('/admin/companies');
      if (response.success) {
        setCompanies(response.companies);

        // İlk yüklemede kullanıcının mevcut şirketini seç
        if (!activeCompany && response.companies.length > 0) {
          const userCompany = response.companies.find(c => c.id === user?.companyId);
          if (userCompany) {
            setActiveCompany(userCompany);
          }
        }
      }
    } catch (error) {
      console.error('Failed to fetch companies:', error);
      // Sadece ağ/sunucu hatası (apiError) DEĞİLSE özel hata mesajını göster,
      // çünkü apiError durumunda apiHelper zaten "Sunucuya ulaşılamıyor" hatasını gösteriyor.
      if (!error.apiError) {
        showError('Şirket listesi alınırken bir hata oluştu');
      }
    } finally {
      setLoading(false);
    }
  };

  const setActiveCompanyById = async (companyId) => {
    try {
      const response = await apiRequest('/admin/set-active-company', {
        method: 'POST',
        body: JSON.stringify({ companyId })
      });

      if (response.success) {
        // Response'tan gelen token'ı güncelle
        if (response.token) {
          localStorage.setItem('auth_token', response.token);
          // AuthContext'teki token state'ini de güncelle
          if (setToken) {
            setToken(response.token);
          }
        }

        // CompanyContext'teki activeCompany'i güncelle
        const selectedCompany = companies.find(company => company.id === parseInt(companyId));
        setActiveCompany(selectedCompany);

        // AuthContext'teki user'ı güncelle
        updateUserInfo({
          companyId: parseInt(companyId),
          companyName: selectedCompany ? selectedCompany.name : 'Şirketiniz'
        });

        // Süper admin için son seçilen şirketi kaydet
        if (user?.role === 'SUPER_ADMIN') {
          localStorage.setItem('lastSelectedCompanyId', companyId);
        }

        // Sayfayı yenile
        window.location.reload();

        return true;
      }
      return false;
    } catch (error) {
      console.error('Failed to set active company:', error);
      showError('Şirket değiştirilemedi');
      return false;
    }
  };

  const value = {
    activeCompany,
    companies,
    loading,
    fetchCompanies,
    setActiveCompanyById
  };

  return (
    <CompanyContext.Provider value={value}>
      {children}
    </CompanyContext.Provider>
  );
}

export function useCompany() {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
} 